<template>
  <section id="mainContent">
    <div class="page-header">
        <div class="header-left-wrapper">
            <ion-icon :name="icon" />
            <h2>{{ headerProps.headerTitle }}</h2>
            <a @click="$router.go(-1)" class="img-back-to" v-if="headerProps.filterOrDate === 'date'">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M11.4375 18.75L4.6875 12L11.4375 5.25M5.625 12H19.3125" stroke="var(--darkBlue)" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </a>
        </div>
        
        <div class="span-wrapper" v-if="headerProps.filterOrDate === 'filter'">
            <span v-for="(value, index) in totalTabs" :key="index" @click="tabSelected = index + 1" :class="tabSelected === index + 1 ? 'span-active' : ''">
                {{ value.name }}
                <div :class="tabSelected === index + 1 ? 'border-bottom-active' : 'border-bottom' " ></div>
            </span>
        </div>

        <div v-if="headerProps.filterOrDate === 'date'" class="header-detail-communication">
            {{ $t("Recebido em:") }} {{ headerProps.headerContent.annoucementDate | formatDateHours }}
        </div>
    </div>
  </section>
</template>

<script>
export default {
    name: 'pageHeader',
    props: {
        icon: {
            required: true
        },
        totalTabs: {
            default: 0,
        },
        headerProps: {
            required: true,
            type: Object,
            default: {
                headerTitle: '',
                filterOrDate: 'filter' || 'date',
                headerContent: {
                    annoucementDate: ''
                }
            }
        }
    },
    data() {
        return {
            tabSelected: '',
        }
    },
    methods: {
    
    },
    beforeMount() {
        this.tabSelected = 1
    },
    watch: {
        tabSelected(newValue) {
            this.$emit('tabSelectedChanged', newValue)
        }
    }
}
</script>

<style scoped lang="scss">
    .page-header {
        transition: 0.5s;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid var(--borderGray) !important;

        ion-icon {
            font-size: 32px;
            color: var(--darkBlue);
        }

        h2 {
            margin: 0;
            padding-left: 10px;
            color: var(--text);
        }

        .header-left-wrapper {
            display: flex;

            .img-back-to {
                display: flex;
                align-self: center;
                position: absolute;
                left: 15px;
                cursor: pointer;
            }
        }

        .header-detail-communication {
            font-weight: 500;
            position: relative;
            color: var(--text);
        }

        .span-wrapper {
            color: var(--text);
            min-width: 320px;
            min-height: 33px;

            display: flex;
            justify-content: space-between;
            align-items: center;

            span {
                display: flex;
                align-items: center;
                align-content: space-between;
                flex-direction: column;
                justify-content: center;
                row-gap: 8px;
                transition: color 0.5s ease-in-out;

                .border-bottom {
                    min-width: 100px;
                    border-bottom: 4px solid #9EA3B0;
                    border-radius: 2px;
                    transition: border 0.5s;
                }
            }

            .span-active {
                color: var(--darkBlue)
            }

            .border-bottom-active {
                min-width: 100px;
                border-bottom: 4px solid var(--darkBlue);
                border-radius: 2px;
            }

            span:hover {
                cursor: pointer;
            }

        }
    }
</style>



// WEBPACK FOOTER //
// src/vue/views/components/layouts/pageHeader.vue